import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

export const getAllReportByStudyInstanceApi = createAsyncThunk(
  REPORTS.GET_ALL_REPORTS_BY_STUDY_INSTANCE_URL,
  async (payload: any, { rejectWithValue }) => {
    try {
      const token = getToken();
      const hospitalId = localStorage.getItem('hospitalId') || sessionStorage.getItem('hospitalId');
      const response = await fetch(REPORTS.GET_ALL_REPORTS_BY_STUDY_INSTANCE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ...payload, hospitalId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || 'Get All Reports By Study Instance failed');
      }

      const result = await response.json();

      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
